import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as actions from 'react/api/actions/stopDetailsPopup';
import ButtonWithIcon from 'react/components/ButtonWithIcon';
import { 
  arrivalHeatMapIcon,
  arrivalHeatMapIconActive
} from 'react/utils/stopDetailsPopupBase64Icons.js';

class ArrivalHeatMapButton extends Component {
  
  toggleArrivalHeatMap = (e) => {
    const {
      routeId, stopId, enableArrivalHeatMapAction, 
      disableArrivalHeatMapAction, arrivalHeatMapIsEnabled, 
      requestArrivalHeatMapAction, removeArrivalHeatMapFromMapAction
    } = this.props;
    e.stopPropagation();
    removeArrivalHeatMapFromMapAction(routeId, stopId);
    if (arrivalHeatMapIsEnabled) {
      disableArrivalHeatMapAction(routeId, stopId);
    } else {
      enableArrivalHeatMapAction(routeId, stopId);
      requestArrivalHeatMapAction(routeId, stopId);
    }
  }

  componenteDidMount = () => {
    const { 
      routeId, stopId, arrivalHeatMapIsEnabled, requestArrivalHeatMapAction 
    } = this.props;
    if (arrivalHeatMapIsEnabled) {
      requestArrivalHeatMapAction(routeId, stopId);
    }
  }

  render() {
    const { arrivalHeatMapIsEnabled, ...others } = this.props;
    return (
      <ButtonWithIcon
      label={Monet.I18n.getResourcesByKey('routeDetails.stopDetailsPopup.arrivalHeatmap')}
      isActive={arrivalHeatMapIsEnabled}
      iconUrl={arrivalHeatMapIcon}
      activeIconUrl={arrivalHeatMapIconActive}
      onClick={this.toggleArrivalHeatMap}
      {...others}
      />
    );
  }
}

ArrivalHeatMapButton.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  arrivalHeatMapIsEnabled: PropTypes.bool.isRequired,
  enableArrivalHeatMapAction: PropTypes.func.isRequired,
  disableArrivalHeatMapAction: PropTypes.func.isRequired,
  requestArrivalHeatMapAction: PropTypes.func.isRequired,
  removeArrivalHeatMapFromMapAction: PropTypes.func.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({ 
  arrivalHeatMapIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'arrivalHeatMapIsEnabled'], false)
});

const mapDispatchToProps = (dispatch) => ({
  enableArrivalHeatMapAction: bindActionCreators(actions.enableArrivalHeatMap, dispatch),
  disableArrivalHeatMapAction: bindActionCreators(actions.disableArrivalHeatMap, dispatch),
  requestArrivalHeatMapAction: bindActionCreators(actions.requestArrivalHeatMap, dispatch),
  removeArrivalHeatMapFromMapAction: bindActionCreators(actions.removeArrivalHeatMapFromMap, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ArrivalHeatMapButton);

